import { render, staticRenderFns } from "./LayoutTavoloDesktop.vue?vue&type=template&id=12951874&scoped=true&"
import script from "./LayoutTavoloDesktop.vue?vue&type=script&lang=js&"
export * from "./LayoutTavoloDesktop.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTavoloDesktop.vue?vue&type=style&index=0&id=12951874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12951874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12951874')) {
      api.createRecord('12951874', component.options)
    } else {
      api.reload('12951874', component.options)
    }
    module.hot.accept("./LayoutTavoloDesktop.vue?vue&type=template&id=12951874&scoped=true&", function () {
      api.rerender('12951874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LayoutTavoloDesktop.vue"
export default component.exports